import { useCustomJS, useDefineAPISchema } from '@elfsight/widget-js-api';
import { PortalNestProvider } from '@elfsight/widget-modal';
import {
  CustomCSS,
  createCustomCSSPrefixClassName,
  useFontsLoader
} from '@elfsight/widget-ui';
import { StorageProvider } from '@elfsight/widget-utils';
import { meta } from './constants/meta';
import type { AnnouncementBarSettings } from './types';
import { BarStateProvider } from './widget/bar-state-provider';
import { MOCK_WIDGET_ID } from './widget/constants';
import { Widget } from './widget/widget';

export function AnnouncementBar(_settings: AnnouncementBarSettings) {
  const {
    widgetId = MOCK_WIDGET_ID,
    font,
    customCSS,
    customJS,
    editMode,
    renderThumbnailMode
  } = _settings;

  const customCSSPrefixClassName = createCustomCSSPrefixClassName(
    meta.alias,
    widgetId
  );

  useDefineAPISchema();
  useCustomJS(customJS, editMode || renderThumbnailMode);
  useFontsLoader([font]);

  return (
    <PortalNestProvider
      customCSSClassName={customCSSPrefixClassName}
      font={font}
    >
      <StorageProvider widgetId={widgetId} name={meta.name}>
        <BarStateProvider>
          <Widget />
        </BarStateProvider>
        <CustomCSS
          customCSS={customCSS}
          prefixClassName={customCSSPrefixClassName}
        />
      </StorageProvider>
    </PortalNestProvider>
  );
}
